import format from "date-fns/format"
import formatRelative from "date-fns/formatRelative"
import formatDistanceToNow from "date-fns/formatDistanceToNow"

import enGB from "date-fns/locale/en-GB"
import enUS from "date-fns/locale/en-US"
import ruRU from "date-fns/locale/ru"

export const locales: {[key: string]: any} = {
  en: enUS,
  ru: ruRU,
  default: enGB,
};

const moscowTimezoneOffsetInSec = 10800;

export function formatDuration(duration: number): string {
  const ss = (duration % 60).toString().padStart(2, "0");
  const mm = Math.floor(duration / 60).toString().padStart(2, "0");

  return `${mm}:${ss}`;
}

export function formatDurationHrs(duration: number): string {
  const ss = (duration % 60).toString().padStart(2, "0");
  const mm = Math.floor(duration % 3600 / 60).toString().padStart(2, "0");
  const hh = Math.floor(duration / 3600).toString().padStart(2, "0");

  return `${hh}:${mm}:${ss}`;
}

export function formatDate(date: number, locale?: string) {
  return format(new Date(date * 1000), "P", {
    locale: locales[locale ?? "default"] ?? locales["default"],
  })
}

export function dateToTimestamp(date: Date): number {
  return Math.floor(date.getTime() / 1000);
}

export function dateToMoscowTimestamp(date: Date) {
  const localTimezoneOffsetInMin = date.getTimezoneOffset();
  const timestamp = dateToTimestamp(date) - localTimezoneOffsetInMin * 60 - moscowTimezoneOffsetInSec
  return timestamp;
}

export function getCurrentMoscowTime(): number {
  const now = new Date();
  const localTimezoneOffset = now.getTimezoneOffset() * 60 * 1000;
  const moscowTimeOffset = 3 * 60 * 60 * 1000;
  return now.getTime() + localTimezoneOffset + moscowTimeOffset;
}

export function formatToMoscowDate(date: number, locale?: string) {
  const localTimezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
  const moscowDate = new Date(date * 1000 + localTimezoneOffset + moscowTimezoneOffsetInSec * 1000);
  return format(moscowDate, "Pp", {
    locale: locales[locale ?? "default"] ?? locales["default"],
  });
}

export function formatTime(datetime: number, locale?: string) {
  return format(new Date(datetime * 1000), "p", {
    locale: locales[locale ?? "default"] ?? locales["default"],
  })
}

export function formatDateTime(datetime: number, locale?: string) {
  return format(new Date(datetime * 1000), "Pp", {
    locale: locales[locale ?? "default"] ?? locales["default"],
  })
}


export function formatRelativeDateTime(datetime: number, locale?: string) {
  const now = Date.now();
  const now0 = new Date(now);
  now0.setHours(0, 0, 0, 0);

  if (Math.abs((datetime * 1000) - now0.getTime()) >= 86400000) {
    return formatDateTime(datetime, locale);
  }

  if (Math.abs((datetime * 1000) - now) < 90000) {
    return formatDistanceToNow(new Date(datetime * 1000), {
      locale: locales[locale ?? "default"] ?? locales["default"], addSuffix: true
    })
  }

  return formatRelative(new Date(datetime * 1000), now, {
    locale: locales[locale ?? "default"] ?? locales["default"],
  })
}
